import { dataHooks as wixDataHooks } from '@wix/data-hooks'

export const dataHooks = wixDataHooks<{
  note: {}
  bullet: {}
  mainButton: {}
}>('wixStudioBulletSplitPantone')
